import { Deserializable } from '../protocols/deserializable';
import { Link } from './link';

export class Attachment implements Deserializable {
  public id!: string;
  public fileName!: string;
  public fileSize!: number;
  public mediaType!: string;
  public md5Hash!: string | null;
  public attachmentTypeId!: number;
  public attachmentType!: string;
  public isInput!: boolean;
  public uploadedById!: number;
  public uploadedByName!: string;
  public uploadedByUserType!: string;
  public uploadedDate!: string;
  public links!: Link[];

  onDeserialize(): void {}
}
